// extracted by mini-css-extract-plugin
module.exports = {"container":"az_vXc","sectionTitle":"az_wXc","tabsContainer":"az_xXc","root":"az_yXc","tab":"az_zXc","selected":"az_AXc","tabContent":"az_BXc"};